import { h, render } from 'preact';

import loadDisqus from './utils/load-disqus';

// just in case this gets removed
window.ttData = window.ttData || {};

// analytics
import(/* webpackChunkName: "analytics" */ '@data-visuals/analytics').then(
  analytics => analytics.init()
);

// related content
const relatedContentContainer = document.getElementById(
  'related-content-container'
);

if (relatedContentContainer && window.ttData.gutenTag) {
  import(/* webpackChunkName: "RelatedContent" */ './components/RelatedContent').then(
    ({ default: RelatedContent }) =>
      render(
        <RelatedContent
          title={'Read more'}
          gutenTag={window.ttData.gutenTag}
        />,
        relatedContentContainer
      )
  );
}

// trending ribbon
const ribbonContainer = document.getElementById('ribbon-container');

if (ribbonContainer) {
  import(/* webpackChunkName: "Ribbon" */ './components/Ribbon').then(
    ({ default: Ribbon }) => render(<Ribbon />, ribbonContainer)
  );
}

// ads
import(/* webpackChunkName: "ads" */ './utils/ad-loader').then(
  ({ default: AdLoader }) => {
    const ads = new AdLoader();
    ads.init();
  }
);

// comments
const activateComments = document.querySelector('#activate-comments');
const commentsContainer = document.querySelector('.container--comments');
const disqusThread = document.querySelector('#disqus_thread');

const intersectionConfig = {
  rootMargin: '500px 0px',
  threshold: 0.01,
};

const commentsObserver = new IntersectionObserver(
  onCommentIntersection,
  intersectionConfig
);

function onCommentIntersection(entries) {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;

    loadDisqus();
    commentsObserver.disconnect();
  });
}

commentsObserver.observe(commentsContainer);

activateComments.addEventListener('click', () => {
  commentsContainer.classList.add('container--comments-loading');

  loadDisqus(() => disqusThread.scrollIntoView());
});



// WEBPACK FOOTER //
// ./kickstart.js